<template>
  <div
    class="tag"
    :style="{
      backgroundColor: backgroundColor,
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      optional: false,
    },
  },
};
</script>
<style scoped lang="scss">
div.tag {
  display: inline-block;
  color: white;
  padding: 0.5em 1em;
  margin: 0 0.5em;
  border-radius: 20px;
  font-weight: bold;
  font-size: 80%;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}
</style>
